//=============================================================================  
//                       <--- Developed By Icon Team --->  
//=============================================================================  
  
// npm packages  
import React, { useState, useContext, useEffect } from "react";  
import DateFnsUtils from "@date-io/date-fns";  
import { toast } from "react-toastify";  
import * as moment from "moment";  
  
// custom pages  
import Context from "context/context";  
import styles from "./styles";  
  
// material-ui  
import Button from "@material-ui/core/Button";  
import Grid from "@material-ui/core/Grid";  
import Card from "@material-ui/core/Card";  
import {  
  MuiPickersUtilsProvider,  
  KeyboardDatePicker,  
} from "@material-ui/pickers";  
import Radio from "@material-ui/core/Radio";  
import FormControlLabel from "@material-ui/core/FormControlLabel";  
import Checkbox from "@material-ui/core/Checkbox";  
  
// material-ui icons  
import HighlightOffIcon from "@material-ui/icons/HighlightOff";  
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";  
  
import { withStyles } from "@material-ui/core/styles";  
  
import TextField from "@material-ui/core/TextField";  
import InputAdornment from "@material-ui/core/InputAdornment";  
import Dashboard from "apis/dashboard/dashboard";  
import searchIcon from "assets/img/Search_Icon.png";  
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";  
import { useTranslation } from "react-i18next";  
import { enUS, fr } from "date-fns/locale";  
import { logEvent } from "helpers/analytics";  
import { useTrackWithGTM } from "helpers/gtm";  
  
  
const CssTextField = withStyles({  
  root: {  
    width: "100%",  
    "& label.Mui-focused": {  
      color: "##D3D3D3",  
    },  
    "& .MuiFormLabel-root": {  
      color: "#707070",  
    },  
  
    "& .MuiInputBase-input": {  
      color: "#707070",  
    },  
    "& .MuiInput-underline:before": {  
      borderBottomColor: "#707070!important",  
    },  
    "& .MuiInput-underline:after": {  
      borderBottomColor: "#707070!important",  
    },  
    "& .MuiOutlinedInput-root": {  
      margin: "0 20px 0 0",  
      height: 36,  
      "& fieldset": {  
        borderColor: "#707070",  
      },  
      "&:hover fieldset": {  
        borderColor: "#707070",  
      },  
      "&.Mui-focused fieldset": {  
        borderColor: "#707070",  
      },  
      "&.MuiOutlinedInput-root": {  
        borderRadius: 10,  
      },  
    },  
  },  
})(TextField);  
  
export default function Filter(props) {  
  const {  
    setStates,  
    setCustomFilterDate,  
    offset,  
    setOffset,  
    filterCard,  
    setFilterCard,  
    customFilterDate,  
    currentTab,  
    customerAccounts,  
    setCustomerAccounts,  
    filterActive,  
    setFilterActive,  
    startDate,  
    setStartDate,  
    endDate,  
    setEndDate,  
    date,  
    setDate,  
    dateValue,  
    setDateValue,  
  
    // =========================================================  
    // POST DATE PROPS  
    // =========================================================  
    postDate,  
    setPostDate,  
    postDateValue,  
    setPostDateValue,  
    customPostFilterDate,  
    setCustomPostFilterDate,  
    startPostDate,  
    setStartPostDate,  
    endPostDate,  
    setEndPostDate,  
  
    orgName,  
    setOrgName,  
    expandPanel,  
    setExpandPanel,  
    setViewMore,  
    setViewMoreEnd,  
    setNoData,  
    viewMore,  
    viewMoreEnd,  
    noData,  
    setData,  
    data,  
    response,  
    setResponse,  
    count,  
    setCount,  
    searchValue,  
    setSearchValue,  
    billingAccounts,  
    setBillingAccounts,  
  } = props;  
  
  const { state, dispatch } = useContext(Context);  
  
  const { getTier, getPoints, getTransaction, search, doFilter, Export } =  
    Dashboard();  
  
  const classes = styles();  
  
  const { trackWithGTM } = useTrackWithGTM();  
  
  const [searchActive, setSearchActive] = useState({  
    earned: false,  
    redeemed: false,  
  });  
  
  const { t, i18n } = useTranslation();  
  
  useEffect(() => {  
    if (state.customerAccounts && state.customerAccounts.length > 0) {  
      setStates({  
        customerAccounts: state.customerAccounts,  
      });  
    }  
  }, []);  
  
  useEffect(() => {  
    if (searchActive[currentTab]) {  
      return;  
    }  
  }, [state.customerAccounts, currentTab, offset]);  
  
  const locale = i18n.language == "fr" ? fr : enUS;  
  
  return (  
    <div className={`${classes.filterCardDiv}`}>  
      <Card  
        className={  
          currentTab === "nonSales"  
            ? classes.filterCardNonSales  
            : classes.filterCard  
        }  
      >  
        <Grid container spacing={2} className={classes.filterCardGridContainer}>  
  
          {/* ========================================================= 
              EXISTING ORDER DATE FILTER 
          ========================================================== */}  
          <Grid  
            item  
            xs={12}  
            md={currentTab == "nonSales" ? 6 : 3}  
            lg={currentTab == "nonSales" ? 6 : 3}  
            className={classes.filterCardGrid}  
          >  
            <div  
              className={classes.filterCardHeadText}  
              style={{ fontSize: 16 }}  
            >  
              {currentTab == "earned" && t("Order Date")}  
              {currentTab == "redeemed" && t("Redemption Date")}  
              {currentTab == "nonSales" && "Date of Transaction"}  
  
              <span  
                className={classes.fiterCardCloseOne}  
                onClick={() => {  
                  setFilterCard({  
                    ...filterCard,  
                    [currentTab]: false,  
                  });  
                }}  
              >  
                <span  
                  style={{  
                    cursor: "pointer",  
                    color: "#2f7cbd",  
                    textDecoration: "underline",  
                  }}  
                >  
                  {t("Close")}  
                </span>  
              </span>  
            </div>  
  
            <Grid container spacing={2}>  
  
              {!customFilterDate[currentTab] && (  
                <React.Fragment>  
                  <Grid item xs={6}>  
                    <Grid container spacing={0}>  
  
                      {/* ===================== 30 DAYS ===================== */}  
                      <Grid item xs={12}>  
                        <FormControlLabel  
                          labelPlacement="end"  
                          control={<Radio color="primary" />}  
                          label={`30 ${t("days")}`}  
                          checked={dateValue[currentTab] === 30}  
                          onClick={() => {  
                            if (dateValue[currentTab] === 30) {  
                              setDate({  
                                ...date,  
                                [currentTab]: false,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 0,  
                              });  
                            } else {  
                              setDate({  
                                ...date,  
                                [currentTab]: true,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 30,  
                              });  
                            }  
                          }}  
                        />  
                      </Grid>  
  
                      {/* ===================== 60 DAYS ===================== */}  
                      <Grid item xs={12}>  
                        <FormControlLabel  
                          labelPlacement="end"  
                          control={<Radio color="primary" />}  
                          label={`60 ${t("days")}`}  
                          checked={dateValue[currentTab] === 60}  
                          onClick={() => {  
                            if (dateValue[currentTab] === 60) {  
                              setDate({  
                                ...date,  
                                [currentTab]: false,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 0,  
                              });  
                            } else {  
                              setDate({  
                                ...date,  
                                [currentTab]: true,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 60,  
                              });  
                            }  
                          }}  
                        />  
                      </Grid>  
  
                      {/* ===================== CUSTOM ===================== */}  
                      <Grid item xs={12}>  
                        <FormControlLabel  
                          value="end"  
                          control={  
                            <Radio  
                              color="primary"  
                              onChange={() => {  
                                setCustomFilterDate({  
                                  ...customFilterDate,  
                                  [currentTab]: true,  
                                });  
  
                                setDate({  
                                  ...date,  
                                  [currentTab]: false,  
                                });  
  
                                setDateValue({  
                                  ...dateValue,  
                                  [currentTab]: 0,  
                                });  
                              }}  
                            />  
                          }  
                          label={t("Custom")}  
                        />  
                      </Grid>  
  
                    </Grid>  
                  </Grid>  
  
                  <Grid item xs={6}>  
                    <Grid container spacing={0}>  
  
                      {/* ===================== 90 DAYS ===================== */}  
                      <Grid item xs={12}>  
                        <FormControlLabel  
                          labelPlacement="end"  
                          control={<Radio color="primary" />}  
                          label={`90 ${t("days")}`}  
                          checked={dateValue[currentTab] === 90}  
                          onClick={() => {  
                            if (dateValue[currentTab] === 90) {  
                              setDate({  
                                ...date,  
                                [currentTab]: false,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 0,  
                              });  
                            } else {  
                              setDate({  
                                ...date,  
                                [currentTab]: true,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 90,  
                              });  
                            }  
                          }}  
                        />  
                      </Grid>  
  
                      {/* ===================== 120 DAYS ===================== */}  
                      <Grid item xs={12}>  
                        <FormControlLabel  
                          labelPlacement="end"  
                          control={<Radio color="primary" />}  
                          label={`120 ${t("days")}`}  
                          checked={dateValue[currentTab] === 120}  
                          onClick={() => {  
                            if (dateValue[currentTab] === 120) {  
                              setDate({  
                                ...date,  
                                [currentTab]: false,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 0,  
                              });  
                            } else {  
                              setDate({  
                                ...date,  
                                [currentTab]: true,  
                              });  
  
                              setDateValue({  
                                ...dateValue,  
                                [currentTab]: 120,  
                              });  
                            }  
                          }}  
                        />  
                      </Grid>  
  
                    </Grid>  
                  </Grid>  
                </React.Fragment>  
              )}  
  
              {customFilterDate[currentTab] && (  
                <React.Fragment>  
  
                  <Grid item xs={12}>  
                    <div className={classes.filterCardSubHeadText}>  
                      {t("Start")}{" "}  
                      <span  
                        style={{ float: "right", cursor: "pointer" }}  
                        onClick={() => {  
                          setCustomFilterDate({  
                            ...customFilterDate,  
                            [currentTab]: false,  
                          });  
                        }}  
                      >  
                        <HighlightOffIcon style={{ verticalAlign: "middle" }} />  
                      </span>  
                    </div>  
  
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>  
                      <KeyboardDatePicker  
                        disableToolbar  
                        variant="inline"  
                        format={  
                          i18n.language == "en"  
                            ? "MM/dd/yyyy"  
                            : "dd/MM/yyyy"  
                        }  
                        margin="normal"  
                        id="date-picker-inline"  
                        value={startDate[currentTab]}  
                        disableFuture={true}  
                        onChange={(date) => {  
                          setStartDate({  
                            ...startDate,  
                            [currentTab]: date,  
                          });  
                        }}  
                        KeyboardButtonProps={{  
                          "aria-label": "change date",  
                        }}  
                        autoOk  
                      />  
                    </MuiPickersUtilsProvider>  
                  </Grid>  
  
                  <Grid item xs={12}>  
                    <div className={classes.filterCardSubHeadText}>  
                      {t("End")}  
                    </div>  
  
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>  
                      <KeyboardDatePicker  
                        disableToolbar  
                        variant="inline"  
                        format={  
                          i18n.language == "en"  
                            ? "MM/dd/yyyy"  
                            : "dd/MM/yyyy"  
                        }  
                        margin="normal"  
                        id="date-picker-inline"  
                        value={endDate[currentTab]}  
                        disableFuture={true}  
                        onChange={(date) => {  
                          setEndDate({  
                            ...endDate,  
                            [currentTab]: date,  
                          });  
                        }}  
                        KeyboardButtonProps={{  
                          "aria-label": "change date",  
                        }}  
                        autoOk  
                      />  
                    </MuiPickersUtilsProvider>  
                  </Grid>  
  
                </React.Fragment>  
              )}  
  
            </Grid>  
          </Grid>  
  
  
          {/* ========================================================= 
              POST DATE FILTER 
              ONLY FOR EARNED 
          ========================================================== */}  
          {currentTab === "earned" && (  
            <Grid  
              item  
              xs={12}  
              md={3}  
              lg={3}  
              className={classes.filterCardGrid}  
            >  
              <div  
                className={classes.filterCardHeadText}  
                style={{ fontSize: 16 }}  
              >  
                {t("Post Date")}  
              </div>  
  
              <Grid container spacing={2}>  
  
                {!customPostFilterDate[currentTab] && (  
                  <React.Fragment>  
  
                    <Grid item xs={6}>  
                      <Grid container spacing={0}>  
  
                        {/* ===================== 30 DAYS ===================== */}  
                        <Grid item xs={12}>  
                          <FormControlLabel  
                            labelPlacement="end"  
                            control={<Radio color="primary" />}  
                            label={`30 ${t("days")}`}  
                            checked={  
                              postDateValue[currentTab] === 30  
                            }  
                            onClick={() => {  
                              if (postDateValue[currentTab] === 30) {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: false,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 0,  
                                });  
                              } else {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: true,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 30,  
                                });  
                              }  
                            }}  
                          />  
                        </Grid>  
  
                        {/* ===================== 60 DAYS ===================== */}  
                        <Grid item xs={12}>  
                          <FormControlLabel  
                            labelPlacement="end"  
                            control={<Radio color="primary" />}  
                            label={`60 ${t("days")}`}  
                            checked={  
                              postDateValue[currentTab] === 60  
                            }  
                            onClick={() => {  
                              if (postDateValue[currentTab] === 60) {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: false,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 0,  
                                });  
                              } else {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: true,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 60,  
                                });  
                              }  
                            }}  
                          />  
                        </Grid>  
  
                        {/* ===================== CUSTOM ===================== */}  
                        <Grid item xs={12}>  
                          <FormControlLabel  
                            value="end"  
                            control={  
                              <Radio  
                                color="primary"  
                                onChange={() => {  
                                  setCustomPostFilterDate({  
                                    ...customPostFilterDate,  
                                    [currentTab]: true,  
                                  });  
  
                                  setPostDate({  
                                    ...postDate,  
                                    [currentTab]: false,  
                                  });  
  
                                  setPostDateValue({  
                                    ...postDateValue,  
                                    [currentTab]: 0,  
                                  });  
                                }}  
                              />  
                            }  
                            label={t("Custom")}  
                          />  
                        </Grid>  
  
                      </Grid>  
                    </Grid>  
  
                    <Grid item xs={6}>  
                      <Grid container spacing={0}>  
  
                        {/* ===================== 90 DAYS ===================== */}  
                        <Grid item xs={12}>  
                          <FormControlLabel  
                            labelPlacement="end"  
                            control={<Radio color="primary" />}  
                            label={`90 ${t("days")}`}  
                            checked={  
                              postDateValue[currentTab] === 90  
                            }  
                            onClick={() => {  
                              if (postDateValue[currentTab] === 90) {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: false,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 0,  
                                });  
                              } else {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: true,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 90,  
                                });  
                              }  
                            }}  
                          />  
                        </Grid>  
  
                        {/* ===================== 120 DAYS ===================== */}  
                        <Grid item xs={12}>  
                          <FormControlLabel  
                            labelPlacement="end"  
                            control={<Radio color="primary" />}  
                            label={`120 ${t("days")}`}  
                            checked={  
                              postDateValue[currentTab] === 120  
                            }  
                            onClick={() => {  
                              if (postDateValue[currentTab] === 120) {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: false,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 0,  
                                });  
                              } else {  
                                setPostDate({  
                                  ...postDate,  
                                  [currentTab]: true,  
                                });  
  
                                setPostDateValue({  
                                  ...postDateValue,  
                                  [currentTab]: 120,  
                                });  
                              }  
                            }}  
                          />  
                        </Grid>  
  
                      </Grid>  
                    </Grid>  
  
                  </React.Fragment>  
                )}  
  
                {customPostFilterDate[currentTab] && (  
                  <React.Fragment>  
  
                    {/* Post Date Start */}  
                    <Grid item xs={12}>  
                      <div className={classes.filterCardSubHeadText}>  
                        {t("Start")}{" "}  
  
                        <span  
                          style={{  
                            float: "right",  
                            cursor: "pointer",  
                          }}  
                          onClick={() => {  
                            setCustomPostFilterDate({  
                              ...customPostFilterDate,  
                              [currentTab]: false,  
                            });  
                          }}  
                        >  
                          <HighlightOffIcon  
                            style={{  
                              verticalAlign: "middle",  
                            }}  
                          />  
                        </span>  
                      </div>  
  
                      <MuiPickersUtilsProvider  
                        utils={DateFnsUtils}  
                        locale={locale}  
                      >  
                        <KeyboardDatePicker  
                          disableToolbar  
                          variant="inline"  
                          format={  
                            i18n.language == "en"  
                              ? "MM/dd/yyyy"  
                              : "dd/MM/yyyy"  
                          }  
                          margin="normal"  
                          id="post-date-start-picker"  
                          value={startPostDate[currentTab]}  
                          disableFuture={true}  
                          onChange={(date) => {  
                            setStartPostDate({  
                              ...startPostDate,  
                              [currentTab]: date,  
                            });  
                          }}  
                          KeyboardButtonProps={{  
                            "aria-label": "change date",  
                          }}  
                          autoOk  
                        />  
                      </MuiPickersUtilsProvider>  
                    </Grid>  
  
                    {/* Post Date End */}  
                    <Grid item xs={12}>  
                      <div className={classes.filterCardSubHeadText}>  
                        {t("End")}  
                      </div>  
  
                      <MuiPickersUtilsProvider  
                        utils={DateFnsUtils}  
                        locale={locale}  
                      >  
                        <KeyboardDatePicker  
                          disableToolbar  
                          variant="inline"  
                          format={  
                            i18n.language == "en"  
                              ? "MM/dd/yyyy"  
                              : "dd/MM/yyyy"  
                          }  
                          margin="normal"  
                          id="post-date-end-picker"  
                          value={endPostDate[currentTab]}  
                          disableFuture={true}  
                          onChange={(date) => {  
                            setEndPostDate({  
                              ...endPostDate,  
                              [currentTab]: date,  
                            });  
                          }}  
                          KeyboardButtonProps={{  
                            "aria-label": "change date",  
                          }}  
                          autoOk  
                        />  
                      </MuiPickersUtilsProvider>  
                    </Grid>  
  
                  </React.Fragment>  
                )}  
  
              </Grid>  
            </Grid>  
          )}  
  
  
          {(currentTab === "earned" || currentTab === "redeemed") && (  
            <Grid item xs={12} md={3} className={classes.filterCardGrid}>  
              <div className={classes.filterCardHeadText}>{t("Business Name")}</div>  
  
              {state.org &&  
                state.org.length > 0 &&  
                state.org.map((o, i) => (  
                  <FormControlLabel  
                    key={i}  
                    control={  
                      <Checkbox  
                        checked={orgName[currentTab]?.includes(o)}  
                        onChange={() => {  
                          if (orgName[currentTab]?.includes(o)) {  
                            let i = orgName[currentTab].findIndex(  
                              (f) => f == o  
                            );  
  
                            setOrgName({  
                              ...orgName,  
                              [currentTab]: [  
                                ...orgName[currentTab].slice(0, i),  
                                ...orgName[currentTab].slice(i + 1),  
                              ],  
                            });  
                          } else {  
                            setOrgName({  
                              ...orgName,  
                              [currentTab]: [...orgName[currentTab], o],  
                            });  
                          }  
                        }}  
                        name="checkedB"  
                        color="primary"  
                      />  
                    }  
                    label={t(o)}  
                  />  
                ))}  
            </Grid>  
          )}  
  
          {(currentTab === "earned" || currentTab === "redeemed") && (  
            <Grid  
              item  
              xs={12}  
              md={3}  
              className={classes.filterCardGrid}  
              style={{ padding: "8px 10px" }}  
            >  
              <div  
                className={classes.filterCardHeadText}  
                style={{ fontSize: 16 }}  
              >  
                {currentTab === "earned"  
                  ? t("Location Account #")  
                  : t("Billing Account number")}  
              </div>  
  
              {currentTab === "earned" ? (  
                <div className="d-flex" style={{ flexWrap: "wrap" }}>  
                  {state.customerAccounts &&  
                    state.customerAccounts.length > 0 &&  
                    state.customerAccounts.map((ca, i) =>  
                      i < 6 ? (  
                        <FormControlLabel  
                          style={{ flex: "1 1 calc(50% - 5px)" }}  
                          key={i}  
                          control={  
                            <Checkbox  
                              checked={customerAccounts[currentTab].includes(  
                                ca  
                              )}  
                              onChange={() => {  
                                if (  
                                  !customerAccounts[currentTab].includes(ca)  
                                ) {  
                                  setCustomerAccounts({  
                                    ...customerAccounts,  
                                    [currentTab]: [  
                                      ...customerAccounts[currentTab],  
                                      ca,  
                                    ],  
                                  });  
                                } else {  
                                  let arr = customerAccounts[currentTab].filter(  
                                    (e) => e !== ca  
                                  );  
  
                                  setCustomerAccounts({  
                                    ...customerAccounts,  
                                    [currentTab]: arr,  
                                  });  
                                }  
                              }}  
                              name="checkedB"  
                              color="primary"  
                            />  
                          }  
                          label={ca}  
                        />  
                      ) : i >= 6 && expandPanel[currentTab] ? (  
                        <React.Fragment>  
                          <FormControlLabel  
                            style={{ flex: "1 1 calc(50% - 5px)" }}  
                            key={i}  
                            control={  
                              <Checkbox  
                                checked={customerAccounts[currentTab].includes(  
                                  ca  
                                )}  
                                onChange={() => {  
                                  if (  
                                    !customerAccounts[currentTab].includes(ca)  
                                  ) {  
                                    setCustomerAccounts({  
                                      ...customerAccounts,  
                                      [currentTab]: [  
                                        ...customerAccounts[currentTab],  
                                        ca,  
                                      ],  
                                    });  
                                  } else {  
                                    let arr = customerAccounts[currentTab].filter(  
                                      (e) => e !== ca  
                                    );  
  
                                    setCustomerAccounts({  
                                      ...customerAccounts,  
                                      [currentTab]: arr,  
                                    });  
                                  }  
                                }}  
                                name="checkedB"  
                                color="primary"  
                              />  
                            }  
                            label={ca}  
                          />  
  
                          {i + 1 === state.customerAccounts.length ? (  
                            <div  
                              onClick={() => {  
                                setExpandPanel({  
                                  ...expandPanel,  
                                  [currentTab]: !expandPanel[currentTab],  
                                });  
                              }}  
                              style={{  
                                width: "100%",  
                                color: "#2F7CBD",  
                                cursor: "pointer",  
                              }}  
                            >  
                              {t("Hide")}  
                            </div>  
                          ) : null}  
                        </React.Fragment>  
                      ) : (  
                        i === 6 && (  
                          <div  
                            onClick={() => {  
                              setExpandPanel({  
                                ...expandPanel,  
                                [currentTab]: !expandPanel[currentTab],  
                              });  
                            }}  
                            style={{  
                              color: "#2F7CBD",  
                              cursor: "pointer",  
                              width: "100%",  
                            }}  
                          >  
                            {t("Expand")}  
                          </div>  
                        )  
                      )  
                    )}  
                </div>  
              ) : (  
                <div>  
                  <FormControlLabel  
                    control={  
                      <Checkbox  
                        checked={billingAccounts[currentTab]?.includes(  
                          state.billingAccount?.customer_account_number  
                        )}  
                        onChange={() => {  
                          if (  
                            billingAccounts[currentTab]?.includes(  
                              state.billingAccount?.customer_account_number  
                            )  
                          ) {  
                            let i = billingAccounts[currentTab].findIndex(  
                              (f) =>  
                                f ==  
                                state.billingAccount?.customer_account_number  
                            );  
  
                            setBillingAccounts({  
                              ...billingAccounts,  
                              [currentTab]: [  
                                ...billingAccounts[currentTab].slice(0, i),  
                                ...billingAccounts[currentTab].slice(i + 1),  
                              ],  
                            });  
                          } else {  
                            setBillingAccounts({  
                              ...billingAccounts,  
                              [currentTab]: [  
                                ...billingAccounts[currentTab],  
                                state.billingAccount?.customer_account_number,  
                              ],  
                            });  
                          }  
                        }}  
                        name="checkedB"  
                        color="primary"  
                      />  
                    }  
                    label={state.billingAccount?.customer_account_number}  
                  />  
                </div>  
              )}  
            </Grid>  
          )}  
  
          <Grid  
            item  
            xs={12}  
            md={currentTab == "nonSales" ? 6 : 3}  
            lg={currentTab == "nonSales" ? 6 : 3}  
          >  
            <span  
              className={classes.fiterCardClose}  
              onClick={() => {  
                setFilterCard({  
                  ...filterCard,  
                  [currentTab]: false,  
                });  
              }}  
            >  
              <span  
                style={{  
                  cursor: "pointer",  
                  color: "#2f7cbd",  
                  textDecoration: "underline",  
                }}  
              >  
                {t("close").toUpperCase()}  
              </span>  
            </span>  
  
            {currentTab !== "redeemed" ? (  
              <div className={classes.searchInputContainer}>  
                <CssTextField  
                  id="search"  
                  placeholder={  
                    currentTab === "nonSales"  
                      ? t("Transaction Type")  
                      : t("Order Number")  
                  }  
                  type={currentTab === "nonSales" ? "text" : "number"}  
                  onKeyDown={blockInvalidCharForText}  
                  variant="outlined"  
                  autoComplete="off"  
                  className={classes.searchInput}  
                  InputProps={{  
                    endAdornment: (  
                      <InputAdornment position="end">  
                        {searchValue[currentTab] &&  
                        searchValue[currentTab].length > 0 ? (  
                          <CloseOutlinedIcon  
                            className={classes.searchInputIcon}  
                            onClick={() => {  
                              setSearchValue({  
                                ...searchValue,  
                                [currentTab]: "",  
                              });  
                            }}  
                          />  
                        ) : (  
                          <img  
                            src={searchIcon}  
                            alt=""  
                            width="20px"  
                            style={{  
                              position: "absolute",  
                              right: "3%",  
                              cursor: "pointer",  
                            }}  
                          />  
                        )}  
                      </InputAdornment>  
                    ),  
                  }}  
                  value={searchValue[currentTab]}  
                  onChange={async (e) => {  
                     const value =
                      currentTab === "nonSales"
                        ? e.target.value
                        : e.target.value.slice(0, 8);

                    setSearchValue({
                      ...searchValue,
                      [currentTab]: value,
                    });
                  }}  
                />  
              </div>  
            ) : (  
              ""  
            )}  
  
            <div  
              className={  
                currentTab === "earned"  
                  ? classes.applyBtnDiv_1  
                  : classes.applyBtnDiv_2  
              }  
            >  
              <Button  
                className={classes.filterCardApplyBtn}  
                onClick={() => {  
  
                  logEvent({  
                    event_type: "filter",  
                    event_name: `Apply_${currentTab}_Filters`,  
                    page_url: window.location.pathname,  
                    user_id: state?.userInfo?.user_id,  
                    session_id: state?.userInfo?.session_id,  
                  });  
  
                  trackWithGTM({  
                    database: state?.userInfo?.loyalty_organization_name,  
                    event: "click",  
                    pathname: window.location.pathname,  
                    userId: state?.userInfo?.user_id,  
                    role_id: state?.userInfo?.role_id,  
                    allstate: state,  
                  });  
  
                  if (currentTab === "earned") {  
                    if (!orgName[currentTab].length > 0) {  
                      toast.error("Please select a Business Name!");  
                      return;  
                    }  
  
                    if (customerAccounts[currentTab].length === 0) {  
                      toast.error("Please select a location!");  
                      return;  
                    }  
                  }  
  
                  if (currentTab === "redeemed") {  
                    if (!billingAccounts[currentTab].length > 0) {  
                      toast.error("Please select a Billing Account Number!");  
                      return;  
                    }  
                  }  
  
                  setData({  
                    ...data,  
                    [currentTab]: data[currentTab].slice(0, 6),  
                  });  
  
                  setOffset({ ...offset, [currentTab]: 1 });  
                  setFilterActive({ ...filterActive, [currentTab]: true });  
                  setViewMore({ ...viewMore, [currentTab]: false });  
                  setViewMoreEnd({ ...viewMoreEnd, [currentTab]: "" });  
                  setNoData({ ...noData, [currentTab]: false });  
                  setResponse({ ...response, [currentTab]: false });  
                  setCount({ ...count, [currentTab]: 0 });  
                }}  
              >  
                <span style={{ lineHeight: 1 }}>{t("Apply Filters")} </span>  
              </Button>  
  
              {filterActive[currentTab] && (  
                <Button  
                  className={classes.filterCardResetBtn}  
                  onClick={() => {  
                    logEvent({  
                      event_type: "Button_click",  
                      event_name: `Filter_Reset`,  
                      page_url: window.location.pathname,  
                      user_id: state?.userInfo?.user_id,  
                      session_id: state?.userInfo?.session_id,  
                    });  
  
                    trackWithGTM({  
                      database: state?.userInfo?.loyalty_organization_name,  
                      event: "click",  
                      pathname: window.location.pathname,  
                      userId: state?.userInfo?.user_id,  
                      role_id: state?.userInfo?.role_id,  
                      allstate: state,  
                    });  
  
                    setStates({  
                      startDate: new Date(),  
                      endDate: new Date(),  
                      date: false,  
                      dateValue: 0,  
                      businessName: [],  
                      customerAccounts: [],  
                    });  
  
                    setFilterCard({  
                      ...filterCard,  
                      [currentTab]: false,  
                    });  
  
                    setFilterActive({  
                      ...filterActive,  
                      [currentTab]: false,  
                    });  
  
                    setCustomerAccounts({  
                      ...customerAccounts,  
                      earned: state.customerAccounts,  
                      redeemed: state.customerAccounts,  
                    });  
  
                    setDate({  
                      ...date,  
                      [currentTab]: false,  
                    });  
  
                    setDateValue({  
                      ...dateValue,  
                      [currentTab]: 0,  
                    });  
  
                    setCustomFilterDate({  
                      ...customFilterDate,  
                      [currentTab]: false,  
                    });  
  
                    setStartDate({  
                      ...startDate,  
                      [currentTab]: new Date(),  
                    });  
  
                    setEndDate({  
                      ...endDate,  
                      [currentTab]: new Date(),  
                    });  
  
                    // =====================================================  
                    // RESET POST DATE  
                    // =====================================================  
                    setPostDate({  
                      ...postDate,  
                      [currentTab]: false,  
                    });  
  
                    setPostDateValue({  
                      ...postDateValue,  
                      [currentTab]: 0,  
                    });  
  
                    setCustomPostFilterDate({  
                      ...customPostFilterDate,  
                      [currentTab]: false,  
                    });  
  
                    setStartPostDate({  
                      ...startPostDate,  
                      [currentTab]: new Date(),  
                    });  
  
                    setEndPostDate({  
                      ...endPostDate,  
                      [currentTab]: new Date(),  
                    });  
  
                    setOrgName({  
                      ...orgName,  
                      earned: state.org,  
                      redeemed: state.org,  
                    });  
  
                    setData({  
                      ...data,  
                      [currentTab]: [],  
                    });  
  
                    setViewMore({  
                      ...viewMore,  
                      [currentTab]: false,  
                    });  
  
                    setViewMoreEnd({  
                      ...viewMoreEnd,  
                      [currentTab]: "",  
                    });  
  
                    setNoData({  
                      ...noData,  
                      [currentTab]: false,  
                    });  
  
                    setOffset({  
                      ...offset,  
                      [currentTab]: 1,  
                    });  
  
                    setResponse({  
                      ...response,  
                      [currentTab]: false,  
                    });  
  
                    setExpandPanel({  
                      ...expandPanel,  
                      [currentTab]: false,  
                    });  
  
                    setCount({  
                      ...count,  
                      [currentTab]: 0,  
                    });  
  
                    setSearchValue({  
                      ...searchValue,  
                      [currentTab]: "",  
                    });  
                  }}  
                >  
                  {t("Reset")}  
                </Button>  
              )}  
            </div>  
          </Grid>  
  
          <Grid item xs={2} className={classes.filterCardBtnGrid}></Grid>  
  
        </Grid>  
      </Card>  
    </div>  
  );  
}
